const envKey =  process.env.REACT_APP_PUBLIC_LOGIN_KEY_HEX;
const SECRET_KEY = envKey 





function bytesToHex(bytes: number[]): string {
  return bytes.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export function encodeLoginCredentials(password: string): string {
  if (!SECRET_KEY) {
    console.error(' ERROR: environment variable is not defined ');
    throw new Error('key is not defined')
  }

  const key = SECRET_KEY
  const resultBytes: number[] = []

  for (let i = 0; i < password.length; i++) {
    const charCode = password.charCodeAt(i)
    const keyCode = key.charCodeAt(i % key.length)
    const xored = charCode ^ keyCode
    resultBytes.push(xored)
  }

  return bytesToHex(resultBytes)
}
